import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "InputBase-root_1cbGN",
  "big": "InputBase-big_WriRn",
  "small": "InputBase-small_2l03S",
  "roundedTopLeft": "InputBase-roundedTopLeft_2dChg",
  "roundedTopRight": "InputBase-roundedTopRight_110YC",
  "roundedBottomRight": "InputBase-roundedBottomRight_3e0In",
  "roundedBottomLeft": "InputBase-roundedBottomLeft_2iRWX",
  "rounded": "InputBase-rounded_GppnX InputBase-roundedTopLeft_2dChg InputBase-roundedTopRight_110YC InputBase-roundedBottomRight_3e0In InputBase-roundedBottomLeft_2iRWX",
  "borderedTop": "InputBase-borderedTop_Q0K0k",
  "borderedRight": "InputBase-borderedRight_3A08H",
  "borderedBottom": "InputBase-borderedBottom_323sL",
  "borderedLeft": "InputBase-borderedLeft_2L07b",
  "bordered": "InputBase-bordered_1njv2 InputBase-borderedTop_Q0K0k InputBase-borderedRight_3A08H InputBase-borderedBottom_323sL InputBase-borderedLeft_2L07b",
  "theme-default": "InputBase-theme-default_xlXUq",
  "theme-error": "InputBase-theme-error_3naRw",
  "theme-disabled": "InputBase-theme-disabled_Y8qs3",
  "hasError": "InputBase-hasError_3poKx InputBase-theme-error_3naRw",
  "disabled": "InputBase-disabled_NeaTT InputBase-theme-disabled_Y8qs3",
  "readonly": "InputBase-readonly_1eVdE"
};
function InputBase({
  tagName = 'input',
  variant = 'big',
  theme,
  hasError,
  disabled,
  readOnly,
  bordered,
  borderedTop = true,
  borderedRight,
  borderedBottom = true,
  borderedLeft,
  rounded,
  roundedTopLeft,
  roundedTopRight,
  roundedBottomRight,
  roundedBottomLeft,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles['theme-default']]: !hasError && !disabled,
    [styles.hasError]: hasError,
    [styles.disabled]: disabled,
    [styles.readonly]: readOnly,
    [styles.bordered]: bordered,
    [styles.borderedTop]: borderedTop,
    [styles.borderedRight]: borderedRight,
    [styles.borderedBottom]: borderedBottom,
    [styles.borderedLeft]: borderedLeft,
    [styles.rounded]: rounded,
    [styles.roundedTopLeft]: roundedTopLeft,
    [styles.roundedTopRight]: roundedTopRight,
    [styles.roundedBottomRight]: roundedBottomRight,
    [styles.roundedBottomLeft]: roundedBottomLeft,
    [styles.big]: variant === 'big',
    [styles.small]: variant === 'small'
  }, className);
  return /*#__PURE__*/_jsx(Base, {
    tagName: tagName,
    disabled: disabled,
    readOnly: readOnly,
    className: rootClasses,
    ...extraProps
  });
}
export default InputBase;